'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, createContext, Context } from 'react';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
export const AmplitudeContext: Context<any> = createContext({});
export enum AMPLITUDE_EVENTS {
  SIGN_IN = 'sign_in',
  LOGOUT_CLICK = 'logout_click',
  SIGN_IN_ERROR = 'sign_in_error',
  DEVICE_IMPORT = 'device_import',
  DEVICE_REBOOT = 'device_reboot',
  COPY_SN = 'copy_sn',
  ACCESS_PROXY = 'access_proxy',
  CHANGE_DEVICES_PER_PAGE = 'change_devices_per_page',
  DEVICE_STATUS_TOOLTIP_SHOWN = 'device_status_tooltip_shown',
  DEVICE_CHART_TOOLTIP_SHOWN = 'device_chart_tooltip_shown',
  VIEW_DEVICE_LOGS = 'view_device_logs',
  VIEW_CLIENT_LOGS = 'view_client_logs',
  OPEN_LOGS_PAGE = 'open_logs_page',
  POOLS_TOOLTIP_SHOWN = 'pools_tooltip_shown',
  CHANGE_POOLS = 'change_pools',
  CHANGE_CLIENTS = 'change_clients',
  EDIT_MODEL_OR_SUB = 'edit_model_or_sub',
  MOVE_DEVICES = 'move_devices',
  FACTORY_RESET = 'factory_reset',
  CHANGE_PASSWORDS = 'change_passwords',
  DELETE_DEVICES = 'delete_devices',
  HRCHART_CHANGE_ALGORITHM = 'hrchart_change_algorithm',
  HRCHART_CHANGE_PERIOD = 'hrchart_change_period',
  HRCHART_SHOW_TOOLTIP = 'hrchart_show_tooltip',
  FILL_UNKNOWN_PASSWORDS = 'fill_unknown_passwords',
  CREATE_FACILITY = 'create_facility',
  AUTOMATION_SELECT_MODELS = 'automation_select_models',
  CREATE_AGENT = 'create_agent',
  DELETE_AGENT = 'delete_agent',
  UPDATE_FACILITY = 'update_facility',
  CREATE_TASK = 'create_task',
  EDIT_TASK = 'edit_task',
  CREATE_CLIENT = 'create_client',
  EXPORT = 'export',
  EDIT_CLIENT = 'edit_client',
  EDIT_BILL = 'edit_bill',
  DOWNLOAD_BILL = 'download_bill',
  DOWNLOAD_MONTH_CONSUMPTION = 'download_month_consumption',
  PAGE_INTERACTION_DURATION = 'page_interaction_duration',
  INVITE_STAFF = 'invite_staff',
  UPDATE_STAFF_ROLE = 'update_staff_role',
  UPDATE_STAFF_FACILITIES = 'update_staff_facilities',
  UPDATE_STAFF_NAME = 'update_staff_name',
  UPDATE_STAFF_EMAIL = 'update_staff_email',
  TOGGLE_AUTO_DIAGNOSTICS = 'toggle_auto_diagnostics',
  TOGGLE_AUTO_CREATE_TASKS = 'toggle_auto_create_tasks',
  CHANGE_AUTORECOVERY_DURATION = 'change_auto_recovery_duration',
  TOGGLE_AUTOUPGRADE = 'toggle_autoupgrade',
  GENERATE_TOPOLOGY = 'generate_topology',
  DELETE_STORAGE_ITEM = 'delete_storage_item',
  SET_RECENT_ACTIVITY_FILTER = 'set_recent_activity_filter',
  SCROLL_RECENT_ACTIVITY = 'scroll_recent_activity',
  OPEN_RECENT_EVENT_DETAILS = 'open_recent_event_details',
  OPEN_DIAGNOSTICS = 'open_diagnostics',
  DEVICE_FILTER_APPLIED = 'device_filter_applied',
  DEVICE_FILTERS_OVERHEATED_ONLY = 'checkbox_overheated_only',
  DEVICE_OVERHEATED_TOOLTIP_SHOWN = 'overheated_tooltip_shown',
  SWITCH_DEVICES_TAB = 'switch_devices_tab',
  OPEN_MAINTENANCE_TASKS = 'open_maintenance_tasks',
  OPEN_TASK_SETTINGS = 'open_task_settings',
  OPEN_MAINTENANCE_TASK = 'open_maintenance_task',
  COMMENT_ADDED_TO_MAINTENANCE_TASK = 'comment_added_to_maintenance_task',
  MAINTENANCE_TASK_STATUS_CHANGED = 'maintenance_task_status_changed',
  DIAGNOSTICS_STARTED = 'diagnostics_started',
  COMPONENT_STATUS_ASSIGNED = 'component_status_assigned',
  COMPONENT_TICKET_CREATED = 'component_ticket_created',
  REASON_FILTER_USED = 'reason_filter_used',
  SEARCH_BY_CLIENT_USED = 'search_by_client_used',
  IMPLEMENTER_FILTER_USED = 'mt_implementer_filter_used',
  CREATOR_FILTER_USED = 'mt_creator_filter_used',
  MAINTENANCE_TASK_DELETED = 'maintenance_task_deleted',
  ASSETS_ADDED_FOR_TASK_TYPE_TASK = 'assets_added_for_task_type_task',
  TASK_TYPE_CREATED = 'task_type_created',
  WORKFLOW_CREATED = 'workflow_created',
  OPEN_ASSET_JOURNAL = 'open_asset_journal',
  ITEM_CREATED = 'item_created',
  CONSUMABLE_CREATED = 'consumable_created',
  ASSET_CREATED_FOR_DEVICE = 'asset_created_for_device',
  ASSET_CREATED_MANUALLY = 'asset_created_manually',
  SINGLE_ASSET_SN_CHANGED = 'single_asset_sn_changed',
  BULK_ASSET_SN_CHANGED = 'bulk_asset_sn_changed',
  MANUAL_FIRMWARE_UPGRADE = 'manual_firmware_upgrade',
  SINGLE_ASSET_LOCATION_CHANGED = 'single_asset_location_changed',
  BULK_ASSET_LOCATION_CHANGED = 'bulk_asset_location_changed',
  SINGLE_ASSET_STATUS_CHANGED = 'single_asset_status_changed',
  BULK_ASSET_STATUS_CHANGED = 'bulk_asset_status_changed',
  SINGLE_ASSET_CLIENT_CHANGED = 'single_asset_client_changed',
  POOL_CHANGE_APPROVED = 'pool_change_approved',
  POOL_CHANGE_DECLINED = 'pool_change_declined',
  POOL_LOCK_MINERS_REVIEWED = 'pool_lock_miners_reviewed',
  BULK_ASSET_CLIENT_CHANGED = 'bulk_asset_client_changed',
  CUSTOMER_FROM_SITE_CREATED = 'customer_from_site_created',
  CUSTOMER_MANUALLY_CREATED = 'customer_manually_created',
  CUSTOMER_STATUS_CHANGED_FROM_LEAD_TO_ACTIVE = 'customer_status_changed_from_lead_to_active',
  OPEN_PLAN_CHANGING_PAGE = 'open_plan_changing_page',
  FREE_PLAN_ASSIGNED_BY_CLIENT = 'free_plan_assigned_by_client',
  CORE_PLAN_ASSIGNED_BY_CLIENT = 'core_plan_assigned_by_client',
  SCALE_PLAN_ASSIGNED_BY_CLIENT = 'scale_plan_assigned_by_client',
  ENTERPRISE_PLAN_ASSIGNED_BY_CLIENT = 'enterprise_plan_assigned_by_client',
  FREE_PLAN_ASSIGNED_BY_MANAGER = 'free_plan_assigned_by_manager',
  CORE_PLAN_ASSIGNED_BY_MANAGER = 'core_plan_assigned_by_manager',
  SCALE_PLAN_ASSIGNED_BY_MANAGER = 'scale_plan_assigned_by_manager',
  ENTERPRISE_PLAN_ASSIGNED_BY_MANAGER = 'enterprise_plan_assigned_by_manager',
  CUSTOM_PLAN_ASSIGNED = 'custom_plan_assigned',
  TRIAL_PLAN_ASSIGNED = 'trial_plan_assigned',
  AUTO_INVOICE_CREATED = 'auto_invoice_created',
  MANUAL_INVOICE_CREATED = 'manual_invoice_created',
  CUSTOM_PLAN_CREATED = 'custom_plan_created',
  INVOICE_CHANGED_STATUS_TO_NEW = 'invoice_changed_status_to_new',
  INVOICE_CHANGED_STATUS_TO_PROCESSING = 'invoice_changed_status_to_processing',
  INVOICE_CHANGED_STATUS_TO_OVERDUE = 'invoice_changed_status_to_overdue',
  INVOICE_CHANGED_STATUS_TO_PAID = 'invoice_changed_status_to_paid',
  INVOICE_CHANGED_STATUS_TO_CANCELLED = 'invoice_changed_status_to_cancelled',
  OPEN_CONTACT_MANAGER_FORM = 'open_contact_manager_form',
  CONTACT_MANAGER_REQUEST_RECEIVED = 'contact_manager_request_received',
  CLICK_ON_TECH_SUPPORT_BUTTON = 'click_on_tech_support_button',
  CUSTOM_PLAN_WITH_BULK_ACTIONS_ASSIGNED = 'custom_plan_with_bulk_actions_assigned',
  CUSTOM_PLAN_WITH_STAFF_MANAGEMENT_ASSIGNED = 'custom_plan_with_staff_management_assigned',
  CUSTOM_PLAN_WITH_CLIENT_MANAGEMENT_ASSIGNED = 'custom_plan_with_client_management_assigned',
  CUSTOM_PLAN_WITH_CLIENT_BILLS_ASSIGNED = 'custom_plan_with_client_bills_assigned',
  CUSTOM_PLAN_WITH_PROXY_ACCESS_ASSIGNED = 'custom_plan_with_proxy_access_assigned',
  CUSTOM_PLAN_WITH_ASSET_MANAGER_ASSIGNED = 'custom_plan_with_asset_manager_assigned',
  CUSTOM_PLAN_WITH_DIAGNOSTICS_ASSIGNED = 'custom_plan_with_diagnostics_assigned',
  CUSTOM_PLAN_WITH_TECH_SUPPORT_24H_ASSIGNED = 'custom_plan_with_tech_support_24h_assigned',
  CUSTOM_PLAN_WITH_TECH_SUPPORT_WORKING_H_ASSIGNED = 'custom_plan_with_tech_support_working_h_assigned',
  CUSTOM_PLAN_WITH_IMPORT_FROM_FILE_ASSIGNED = 'custom_plan_with_import_from_file_assigned',
  CUSTOM_PLAN_WITH_AUTO_POOL_ASSIGNED = 'custom_plan_with_auto_pool_assigned',
  CUSTOM_PLAN_WITH_AUTO_FIRMWARE_UPGRADE_ASSIGNED = 'custom_plan_with_auto_firmware_upgrade_assigned',
  CUSTOM_PLAN_WITH_BUILDER_ASSIGNED = 'custom_plan_with_builder_assigned',
  CUSTOM_PLAN_WITH_ADVANCED_TASK_MANAGER_ASSIGNED = 'custom_plan_with_advanced_task_manager_assigned',
  OPEN_TASK_TYPE = 'open_task_type',
  OPEN_TYPED_TASK = 'open_typed_task',
  CREATE_TYPED_TASK_EXTERNAL = 'create_typed_task_external',
  CREATE_TYPED_TASK_INTERNAL = 'create_typed_task_internal',
  CHANGE_STATUS_TYPED_TASK = 'change_status_typed_task',
  COMMENTS_INTERACTION_TYPED_TASK = 'comments_interaction_typed_task',
  UPDATE_TYPED_TASK = 'update_typed_task',
  CLICK_ON_CREATE_URL = 'click_on_create_url',
  CREATE_NEW_WATCHER_URL = 'create_new_watcher_url',
  OPEN_TAX_DETAILS = 'open_tax_details',
  CREATE_NEW_DETAILS = 'create_new_details',
  MARK_DETAILS_AS_UPTODATE = 'mark_details_as_uptodate',
  CLICK_ON_DOWNLOAD_REPORT_BUTTON = 'click_on_download_report_button',
  CLICK_ON_REGENERATE_REPORT = 'click_on_regenerate_report',
  CLICK_ON_MARK_AS_SENT = 'click_on_mark_as_sent',
  CLICK_ON_HELPCENTER = 'click_on_helpcenter',
  CLICK_ON_USERGUIDE = 'click_on_userguide',
  CLICK_ON_SENT_FEEDBACK = 'click_on_sent_feedback',
  SENT_FEEDBACK = 'sent_feedback',
  SEARCH_USED = 'search_used',
  BASIC_TASKS_DEACTIVATION = 'basic_tasks_deactivation',
  ADD_NEW_SC = 'add_new_sc',
  EDIT_SC = 'edit_sc',
  DELETE_SC = 'delete_sc',
  ADD_NEW_COMPONENT_STATUS = 'add_new_component_status',
  EDIT_COMPONENT_STATUS = 'edit_component_status',
  DELETE_COMPONENT_STATUS = 'delete_component_status',
  ADD_NEW_REASON = 'add_new_reason',
  EDIT_REASON = 'edit_reason',
  DELETE_REASON = 'delete_reason',
  MT_WORKFLOW_CHANGING = 'mt_workflow_changing',
  CLICK_ON_LINK_TO_DEVICE = 'click_on_link_to_device',
  CLICK_ON_LINK_TO_INTERFACE = 'click_on_link_to_interface',
  DEVICE_SEARCH = 'device_search',
  CLICK_ON_NOTIFICATIONS_ICON = 'click_on_notifications_icon',
  CHANGE_NOTIFICATIONS_LIST = 'change_notifications_list',
  SELECT_VALUES_IN_NOTIFICATIONS_CATEGORY = 'select_values_in_notifications_category',
  TELEGRAM_NOTIFICATIONS_ACTIVATED = 'telegram_notifications_activated',
  EMAIL_NOTIFICATION_ACTIVATED = 'email_notification_activated',
  SILENCE_TIME_WAS_SET = 'silence_time_was_set',
  CLICK_ON_DOWNLOADING_REPORT = 'click_on_downloading_report',
  CLICK_ON_RELEASE_NOTES_TAB = 'click_on_release_notes_tab',
  CLICK_ON_RELEASE_NOTES_IN_HC = 'click_on_release_notes_in_hc',
  RELATED_TASK_ADDED = 'related_task_added',
  FILTER_BY_COMPONENT_STATUS = 'filter_by_component_status',
  BULK_DELETE_TASKS = 'bulk_delete_tasks',
  FILTER_BY_TICKET = 'filter_by_ticket',
  FILTER_BY_COMPONENT = 'filter_by_component',
  POWER_SCHEDULES_CLICK_ICON = 'click_power_control_icon',
  POWER_SCHEDULES_CLICK_NEW_SCHEDULE = 'click_new_power_control_schedule',
  POWER_SCHEDULES_CLICK_CHANGE_SCHEDULE = 'click_change_power_control_schedule',
  POWER_SCHEDULES_CLICK_DELETE_SCHEDULE = 'click_delete_from_power_control_schedule',
  POWER_SCHEDULES_VIEW_CREATE_SCHEDULE = 'view_create_power_control_schedule',
  POWER_SCHEDULES_VIEW_SCHEDULE_LIST_POPUP = 'view_schedule_list_popup',
  POWER_SCHEDULES_CLICK_SCHEDULE_CARD_MINERS_COUNT = 'click_schedule_card_miners_count',
  POWER_SCHEDULES_CLICK_SCHEDULE_THREE_DOTS = 'click_schedule_three_dots',
  POWER_SCHEDULES_CLICK_SCHEDULE_EDIT = 'click_schedule_edit',
  POWER_SCHEDULES_CLICK_SCHEDULE_VIEW_LOGS = 'click_schedule_view_logs',
  POWER_SCHEDULES_CLICK_SCHEDULE_DELETE = 'click_schedule_delete',
  POWER_SCHEDULES_VIEW_EDIT_SCHEDULE = 'view_edit_schedule',
  POWER_SCHEDULES_VIEW_CHANGE_SCHEDULE = 'view_change_power_control_schedule',
  POWER_SCHEDULES_SELECT_NEW_SCHEDULE_FOR_MINERS = 'select_new_schedule_for_miners',
  POWER_SCHEDULES_CLICK_SCHEDULE_DELETE_FROM_TOOLTIP = 'click_schedule_delete_from_tooltip',
  POWER_SCHEDULES_START_CLICKED = 'power_control_start_clicked',
  POWER_SCHEDULES_STOP_CLICKED = 'power_control_stop_clicked',
  POOL_LOCK_UNLOCK_CLICKED = 'pool_lock_unlock_clicked',
  POOL_LOCK_CLICKED = 'pool_lock_clicked',
  POOL_UNLOCK_CLICKED = 'pool_unlock_clicked',
  POOL_CHANGE_LOCK_CLICKED = 'pool_change_lock_clicked',
  POOL_CHANGE_LOCK_HOVERED = 'pool_change_lock_hovered',
  CLICK_ON_EXPORT_CLIENTS_DATA = 'click_on_export_clients_data',
  CLICK_ON_DOWNLOAD_REPORT_CLIENTS = 'click_on_download_report_clients',
  CLICK_ON_EXPORT_TASKS_BUTTON = 'click_on_export_tasks_button',
  CLICK_ON_DOWNLOAD_EXPORT_FILE_TASKS = 'click_on_download_export_file_tasks',
  DOWNLOADED_EXPORT_FILE = 'downloaded_export_file',
  CLICK_ON_CREATE_TASK_CLIENT = 'click_on_create_task_client',
  TOPOLOGY_PAGE_OPENED = 'topology_page_opened',
  TOPOLOGY_ADD_CLICKED = 'topology_add_clicked',
  TOPOLOGY_CREATED = 'topology_created',
  TOPOLOGY_EDIT_OPENED = 'topology_edit_opened',
  TOPOLOGY_SAVED = 'topology_saved',
  BLOCK_ADD_CLICKED = 'block_add_clicked',
  BLOCK_CREATED = 'block_created',
  BLOCK_EDITED = 'block_edited',
  BLOCK_DUPLICATED = 'block_duplicated',
  BLOCK_MOVED = 'block_moved',
  BLOCKS_BULK_MOVED = 'blocks_bulk_moved',
  BLOCK_DELETED = 'block_deleted',
  BLOCKS_BULK_DELETED = 'blocks_bulk_deleted',
  CELL_POPOVER_OPENED = 'cell_popover_opened',
  CELL_VALUE_COPIED = 'cell_value_copied',
  TOPOLOGY_DUPLICATE_CLICKED = 'topology_duplicate_clicked',
  TOPOLOGY_DUPLICATED = 'topology_duplicated',
  TOPOLOGY_DELETE_CLICKED = 'topology_delete_clicked',
  BLOCKS_BULK_NOTE_ADDED = 'blocks_bulk_note_added',
  BLOCK_NOTE_VIEWED = 'block_note_viewed',
  FACILITY_MAP_OPENED_FROM_TABLE_VIEW = 'facility_map_opened_from_table_view',
  FACILITY_MAP_UNAVAILABLE_TOOLTIP_SHOWN = 'facility_map_unavailable_tooltip_shown',
  FACILITY_MAP_VIEW_SELECTED = 'facility_map_view_selected',
  FACILITY_MAP_MODE_CHANGED = 'facility_map_mode_changed',
  FACILITY_MAP_CELL_POPOVER_OPENED = 'facility_map_cell_popover_opened',
  CELL_VIEW_IN_TABLE_CLICKED = 'cell_view_in_table_clicked',
  BLOCK_VIEW_IN_TABLE_CLICKED = 'block_view_in_table_clicked',
  FACILITY_MAP_SEARCH_USED = 'facility_map_search_used',
  CELL_PROXY_OPENED_FROM_POPOVER = 'cell_proxy_opened_from_popover',
}
export const toAmplitudeUserID = (id: number) => String(id).padStart(5, '0');
export type AmplitudeContextValues = {
  getUserID: typeof amplitude.getUserId;
  setUserID: typeof amplitude.setUserId;
  trackEvent: typeof amplitude.track;
  identify: typeof amplitude.identify;
  setOptOut: typeof amplitude.setOptOut;
};
const AmplitudeContextProvider = t0 => {
  const $ = _c(7);
  const {
    children,
    apiKey,
    region
  } = t0;
  let t1;
  let t2;
  if ($[0] !== apiKey || $[1] !== region) {
    t1 = () => {
      if (!apiKey) {
        return;
      }
      const sessionReplayTracking = sessionReplayPlugin({
        sampleRate: 1
      });
      amplitude.add(sessionReplayTracking);
      amplitude.init(apiKey, {
        autocapture: false,
        transport: "beacon",
        serverZone: region || "EU",
        flushIntervalMillis: 250
      });
    };
    t2 = [apiKey, region];
    $[0] = apiKey;
    $[1] = region;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      getUserID: amplitude.getUserId,
      setUserID: amplitude.setUserId,
      trackEvent: amplitude.track,
      identify: amplitude.identify,
      setOptOut: amplitude.setOptOut
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const values = t3;
  let t4;
  if ($[5] !== children) {
    t4 = <AmplitudeContext.Provider value={values}>{children}</AmplitudeContext.Provider>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default AmplitudeContextProvider;